import { __rest } from "tslib";
import React from "react";
import connect from "Shared/connect";
import classnames from "classnames";
import { isIOS } from "Shared/device-type";
import { scrollPosition } from "SiteLayout/Root";
import { ESC } from "Shared/keyboard";
import { TINY } from "Shared/breakpoints";
import Transition from "Shared/Transition";
import * as styles from "./base.scss";
export let currentOpenOverlay = null;
class Overlay extends React.Component {
    componentWillUnmount() {
        this.disable();
    }
    UNSAFE_componentWillMount() {
        this.props.enabled && this.enable();
    }
    enable() {
        // The key down event must be attached to window and not on `<Root />` for the callback to be
        // called even if active element is `<body />`
        window.addEventListener("keydown", this.keyDown);
        this.freezeBodyScroll(true);
        if (!!this.props.isPersistent)
            return;
        currentOpenOverlay &&
            currentOpenOverlay !== this &&
            currentOpenOverlay.close();
        currentOpenOverlay = this;
    }
    disable() {
        window.removeEventListener("keydown", this.keyDown);
        this.freezeBodyScroll(false);
        if (currentOpenOverlay === this) {
            currentOpenOverlay = null;
        }
    }
    keyDown(e) {
        if (e.keyCode === ESC && currentOpenOverlay) {
            currentOpenOverlay.close();
            currentOpenOverlay = null;
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.enabled !== nextProps.enabled) {
            this.freezeBodyScroll(nextProps.enabled);
            if (nextProps.enabled) {
                this.enable();
            }
            else {
                this.disable();
            }
        }
    }
    close() {
        if (this.props.enabled && !!this.props.onClose) {
            this.props.onClose();
        }
    }
    setCurrentScrollPosition(newPosition) {
        if (isIOS()) {
            // In some cases we need to modify the scroll position during the time
            // an overlay is open. And because of iOS we set it to position: fixed
            // which means that it won't react to setting the bodys scroll position,
            // we have to update the fixed positioning.
            this.currentScrollPosition = newPosition;
            document.body.style.top = this.currentScrollPosition * -1 + "px";
        }
    }
    freezeBodyScroll(freeze) {
        // Don't hide overflow if there's a scroll bar. Note
        // that mobile browsers doesn't have scroll bar, so this
        // only applies to desktop browsers.
        if (this.props.currentBreakpoint <= TINY) {
            const bodyClassList = document.body.classList;
            if (freeze) {
                if (isIOS()) {
                    this.currentScrollPosition = scrollPosition();
                    // Setting position fixed is the only way to prevent body scroll
                    // to occur on iOS when you reach the bottom it the scroll position in
                    // a floating layer.
                    document.body.style.position = "fixed";
                    document.body.style.left = "0";
                    document.body.style.right = "0";
                    document.body.style.top = this.currentScrollPosition * -1 + "px";
                }
                bodyClassList.add(styles.freezescroll);
            }
            else {
                bodyClassList.remove(styles.freezescroll);
                if (isIOS()) {
                    document.body.style.position = "";
                    document.body.style.left = "";
                    document.body.style.right = "";
                    document.body.style.top = "";
                    scrollPosition(this.currentScrollPosition);
                }
            }
        }
    }
    render() {
        const _a = this.props, { className, enabled, children, onClose, currentBreakpoint, dispatch, wrapperClassName, overlayClassName, ignoreAnimation, isTransparent, isPersistent } = _a, passProps = __rest(_a, ["className", "enabled", "children", "onClose", "currentBreakpoint", "dispatch", "wrapperClassName", "overlayClassName", "ignoreAnimation", "isTransparent", "isPersistent"]);
        return (React.createElement("div", { className: classnames(styles.base, this.props.className) },
            React.createElement(Transition, { in: this.props.enabled, timeout: 200 }, (active) => (React.createElement("div", Object.assign({}, passProps, { onClick: () => this.close(), className: classnames(styles.overlay, {
                    [styles.active]: active,
                    [styles.ignoreAnim]: this.props.ignoreAnimation,
                    [styles.transparent]: this.props.isTransparent,
                }, this.props.overlayClassName) })))),
            React.createElement("div", { className: classnames(styles.wrapper, this.props.wrapperClassName) }, this.props.children)));
    }
}
Overlay.defaultProps = {
    enabled: true,
};
export default connect((state) => ({
    currentBreakpoint: state.currentBreakpoint,
}))(Overlay);
